var GlobalUnreadsCountSelector = /** @class */ (function () {
    function GlobalUnreadsCountSelector(config) {
        this.config = config;
    }
    GlobalUnreadsCountSelector.prototype.getCount = function (state) {
        if (state.globalUnreadsCount.resyncCountdown !== undefined) {
            return {
                count: this.config.maxUnreadsCount,
                overflow: true,
            };
        }
        var unreadsCount = state.globalUnreadsCount.chatroomsCount;
        var count = Math.min(unreadsCount, this.config.maxUnreadsCount);
        var overflow = unreadsCount > this.config.maxUnreadsCount;
        return {
            count: count,
            overflow: overflow,
        };
    };
    GlobalUnreadsCountSelector.prototype.isMarkedUnread = function (state, chatroomId) {
        return Boolean((state.globalUnreadsCount.chatroomIds || {})[chatroomId]);
    };
    GlobalUnreadsCountSelector.prototype.isUnreadCountLoaded = function (state) {
        return Boolean(state.globalUnreadsCount.resyncCountdown !== undefined || state.globalUnreadsCount.chatroomIds);
    };
    GlobalUnreadsCountSelector.prototype.getUnreadChatroomIds = function (state) {
        var _a;
        return Object.keys(((_a = state.globalUnreadsCount) === null || _a === void 0 ? void 0 : _a.chatroomIds) || {});
    };
    return GlobalUnreadsCountSelector;
}());
export { GlobalUnreadsCountSelector };
export default (function (config) {
    return new GlobalUnreadsCountSelector(config);
});
